module.exports = __webpack_public_path__ + "img/thumbnail_Cheetah_m_normal.f615af0a.png";